<template>
	<div class="container__buttondropdown">
		<button
			:id="id"
			ref="ref__dropdownbutton"
			:class="['ui button', semanticClass, color, { outlined: outlined }, { iconed: iconed }]"
			:disabled="disabled"
			@click="dropdownAtivo = !dropdownAtivo"
		>
			<span v-if="!iconed">{{ labelSelecionada }}</span>
			<i :class="icon" />
		</button>
		<div
			v-closable="{
				exclude: ['ref__dropdownbutton'],
				handler: 'fecharDropdown',
			}"
			:style="{ width: widthFull ? '100%' : 'auto' }"
			:class="[
				'container__buttondropdown__drop',
				{ iconed: iconed },
				{ dropdownativo: dropdownAtivo },
			]"
		>
			<span
				v-for="(option, key) in options"
				:id="option.value"
				:key="key"
				@click="changeValue($event)"
				>{{ option.label }}</span
			>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		// diz se o botão contém label ou apenas icone
		iconed: {
			type: Boolean,
			default: false,
		},
		widthFull: {
			type: Boolean,
			default: true,
		},
		//icone que deve ser mostrado no botão, essencialmente tirado do fontawesome
		icon: {
			type: String,
			default: 'fas fa-caret-down',
		},
		/**
		 * Cor do dropdown
		 */
		color: {
			type: String,
			default: 'trv-default',
			validator: (value) => {
				return (
					['trv-default', 'trv-primary', 'trv-secondary', 'trv-error', 'trv-neutral'].indexOf(
						value,
					) !== -1
				)
			},
		},
		/**
		 * Dropdown habilitado ou não
		 */
		disabled: {
			type: Boolean,
			default: false,
		},
		id: {
			type: String,
		},
		/**
		 * Label do dropdown
		 */
		label: String,
		/**
		 * Array com os valores que estarão disponiveis no dropdown
		 */
		options: { type: Array, required: true },
		/**
		 * Dropdown com estilo sem preenchimento só contorno
		 */
		outlined: { type: Boolean, default: false },
		/**
		 * Classes que fazem parte do semantic
		 */
		semanticClass: String,
		/**
		 * Valor que sera feito o bind
		 */
		value: String,
	},
	data: () => {
		return {
			/**
			 * Trocar entre dropdown ativo ou não
			 */
			dropdownAtivo: false,
		}
	},
	computed: {
		labelSelecionada() {
			return this.options.find((f) => f.value === this.value)
				? this.options.find((f) => f.value === this.value).label
				: this.label
		},
	},
	methods: {
		/**
		 * Faz o bind com o valor do dropdown que foi selecionado
		 */
		changeValue(value) {
			// if (value.path[4].id) this.$emit("id", value.path[4].id);
			this.fecharDropdown()
			this.$emit('input', value.target.id)
		},
		/**
		 * Fecha o dropdown
		 */
		fecharDropdown() {
			this.dropdownAtivo = false
		},
	},
}
</script>

<style scoped>
.container__buttondropdown {
	position: relative;
	font-size: 0.78rem;
	font-family: 'Open Sams', sans-serif;
}

.ui.button {
	width: 100%;
	color: white;
	font-weight: 100;
	display: flex;
	justify-content: space-between;
}

.ui.button:disabled {
	cursor: not-allowed;
	background-color: var(--color-gray);
}

.trv-default,
.trv-default:hover,
.trv-default:focus {
	background-color: rgb(var(--color-default));
}
.trv-primary,
.trv-primary:hover,
.trv-primary:focus {
	background-color: rgb(var(--color-primary));
}
.trv-secondary,
.trv-secondary:hover,
.trv-secondary:focus {
	background-color: rgb(var(--color-secondary));
}
.trv-error,
.trv-error:hover,
.trv-error:focus {
	background-color: rgb(var(--color-error));
}
.trv-neutral,
.trv-neutral:hover,
.trv-neutral:focus {
	background-color: rgb(var(--color-neutral));
	color: #777982 !important;
}

.outlined {
	background-color: white;
	transition: background-color 0.2s ease-in-out;
}

.outlined.trv-default {
	border: 1px solid rgb(var(--color-default));
	color: rgb(var(--color-default));
}
.outlined.trv-default:hover,
.outlined.trv-default:focus {
	background-color: rgba(var(--color-default));
	color: white;
}

.outlined.trv-primary {
	border: 1px solid rgb(var(--color-primary));
	color: rgb(var(--color-primary));
}
.outlined.trv-primary:hover,
.outlined.trv-primary:focus {
	background-color: rgba(var(--color-primary));
	color: white;
}

.outlined.trv-secondary {
	border: 1px solid rgb(var(--color-secondary));
	color: rgb(var(--color-secondary));
}
.outlined.trv-secondary:hover,
.outlined.trv-secondary:focus {
	background-color: rgba(var(--color-secondary));
	color: white;
}

.outlined.trv-error {
	border: 1px solid rgb(var(--color-error));
	color: rgb(var(--color-error));
}
.outlined.trv-error:hover,
.outlined.trv-error:focus {
	background-color: rgba(var(--color-error));
	color: white;
}

.outlined.trv-neutral {
	border: 1px solid rgb(var(--color-neutral));
	color: rgb(var(--color-neutral));
}
.outlined.trv-neutral:hover,
.outlined.trv-neutral:focus {
	background-color: rgba(var(--color-neutral));
	color: white;
}

.container__buttondropdown__drop {
	display: none;
	position: absolute;
	width: fit-content;
	background-color: white;
	border-bottom-left-radius: 0.28rem;
	border-bottom-right-radius: 0.28rem;
	transform: translateY(-3px);
	z-index: 50;
	max-height: 30vh;
	overflow-y: auto;
}

.ui.button.trv-default + .container__buttondropdown__drop {
	border-right: 1px solid rgb(var(--color-default));
	border-left: 1px solid rgb(var(--color-default));
	border-bottom: 1px solid rgb(var(--color-default));
	color: rgb(var(--color-default));
}

.ui.button.trv-default + .container__buttondropdown__drop.iconed {
	border-top: 1px solid rgb(var(--color-default));
	border-top-right-radius: 0.28rem;
	border-top-left-radius: 0.28rem;
}

.ui.button.trv-primary + .container__buttondropdown__drop {
	border-right: 1px solid rgb(var(--color-primary));
	border-left: 1px solid rgb(var(--color-primary));
	border-bottom: 1px solid rgb(var(--color-primary));
	color: rgb(var(--color-primary));
}
.ui.button.trv-secondary + .container__buttondropdown__drop {
	border-right: 1px solid rgb(var(--color-secondary));
	border-left: 1px solid rgb(var(--color-secondary));
	border-bottom: 1px solid rgb(var(--color-secondary));
	color: rgb(var(--color-secondary));
}
.ui.button.trv-error + .container__buttondropdown__drop {
	border-right: 1px solid rgb(var(--color-error));
	border-left: 1px solid rgb(var(--color-error));
	border-bottom: 1px solid rgb(var(--color-error));
	color: rgb(var(--color-error));
}
.ui.button.trv-neutral + .container__buttondropdown__drop {
	border-right: 1px solid rgb(var(--color-neutral));
	border-left: 1px solid rgb(var(--color-neutral));
	border-bottom: 1px solid rgb(var(--color-neutral));
	color: #999;
}

.container__buttondropdown__drop.dropdownativo {
	display: flex;
	flex-direction: column;
	left: auto;
	right: 0;
}

.container__buttondropdown__drop > span {
	padding: 0.2rem 0.5rem;
	cursor: pointer;
	width: 100%;
	text-align: start;
}

.ui.button.trv-default + .container__buttondropdown__drop > span {
	border-bottom: 1px solid rgba(var(--color-default), 0.2);
}
.ui.button.trv-primary + .container__buttondropdown__drop > span {
	border-bottom: 1px solid rgba(var(--color-primary), 0.2);
}
.ui.button.trv-secondary + .container__buttondropdown__drop > span {
	border-bottom: 1px solid rgba(var(--color-secondary), 0.2);
}
.ui.button.trv-error + .container__buttondropdown__drop > span {
	border-bottom: 1px solid rgba(var(--color-error), 0.2);
}
.ui.button.trv-neutral + .container__buttondropdown__drop > span {
	border-bottom: 1px solid rgba(var(--color-neutral), 1);
}

.ui.button.trv-default + .container__buttondropdown__drop > span:hover {
	color: white;
	background-color: rgba(var(--color-default));
}
.ui.button.trv-primary + .container__buttondropdown__drop > span:hover {
	color: white;
	background-color: rgba(var(--color-primary));
}
.ui.button.trv-secondary + .container__buttondropdown__drop > span:hover {
	color: white;
	background-color: rgba(var(--color-secondary));
}
.ui.button.trv-error + .container__buttondropdown__drop > span:hover {
	color: white;
	background-color: rgba(var(--color-error));
}
.ui.button.trv-neutral + .container__buttondropdown__drop > span:hover {
	color: #555;
	background-color: rgba(var(--color-neutral));
}
</style>
